import React from 'react';

import { getAsset } from '../../../../../../../util/assets';

const Placeholder = () => {
  const splash = getAsset('/splash-illustration-blue.svg');
  const waldoMagnified = getAsset('/waldo-magnified.svg');

  return (
    <div className="py-5 text-center">
      <div className="waldo-searching-animation">
        <img
          src={waldoMagnified}
          alt=""
          className="waldo-searching-magnifier"
        />
        <img src={splash} alt="" className="waldo-searching-splash" />
      </div>

      <p className="text-extra-bold text-dark mb-0 mt-4">
        Fetching your photos!
      </p>
    </div>
  );
};

export default Placeholder;
